import 'jquery';
import { horizontalScroll } from './horizontalscroll.js';
import { Breakpoints } from './breakpoints.js';

export class Ticker {

    init(selector, options, ftscrollerOptions, responsiveOptions, responsiveFtscrollerOptions) {
        var optionsDefault = {
            addButtons: true,
            addOverflowIndicators: false,
            buttonAlignment: { left: 'edge' }
        };
        var ftscrollerOptionsDefault = {
        };

        var responsiveOptionsDefault = {
            addButtons: true,
            addOverflowIndicators: false,
            buttonAlignment: { left: 'edge-inside', right: 'edge-inside' }
        };
        var responsiveFtscrollerOptionsDefault = {
        };

        options = $.extend(true, optionsDefault, options);
        ftscrollerOptions = $.extend(true, ftscrollerOptionsDefault, ftscrollerOptions);

        responsiveOptions = $.extend(true, responsiveOptionsDefault, responsiveOptions);
        responsiveFtscrollerOptions = $.extend(true, responsiveFtscrollerOptionsDefault, responsiveFtscrollerOptions);

        var tickers;

        if (selector) {
            tickers = $(selector);
        } else {
            tickers = $('.unify-ticker');
        }

        var scrollers = [];

        var that = this;
        tickers.each(function (idx, elTicker) {

            var scroller = that._setUp(elTicker, options, ftscrollerOptions, responsiveOptions, responsiveFtscrollerOptions);
            scrollers.push(scroller);
        });

        return scrollers;
    }

    _setUp(elTicker, options, ftscrollerOptions, responsiveOptions, responsiveFtscrollerOptions) {
        var $ticker = $(elTicker);

        $ticker.addClass('unify-ticker--responsive');

        var $tickerItems = $ticker.children('.unify-ticker__item');
        $tickerItems.remove();

        var elScrollerWrapper = document.createElement('div');
        var elItemWrapper = document.createElement('div');

        elScrollerWrapper.classList.add('unify-ticker-scrollerwrapper');
        elItemWrapper.classList.add('unify-ticker-itemwrapper');

        $(elItemWrapper).append($tickerItems);
        $(elScrollerWrapper).append(elItemWrapper);
        $ticker.append(elScrollerWrapper);

        var scroller;
        var breakpoints = new Breakpoints();
        if (breakpoints.isXs()) {
            scroller = horizontalScroll.inject(elScrollerWrapper, responsiveOptions, responsiveFtscrollerOptions)[0];
        } else {
            options.externalButtonLocation = elScrollerWrapper;
            scroller = horizontalScroll.inject(elScrollerWrapper, options, ftscrollerOptions)[0];
        }
        return scroller;
    }

}
